<script>
  import NewsItem from '@components/List/NewsItem'
  // import Bulletin from '@components/List/Bulletin'
  import Slick from 'vue-slick'
  import 'slick-carousel/slick/slick.css'
  import DialogLogin from '@components/Dialog/Login';
  import DialogDealer from '@components/Dialog/Dealer';
  import DialogDealerGroup from '@components/Dialog/DealerGroup';
  import { authComputed } from '@store/helpers'

  export default {
    components: {
      NewsItem,
      Slick,
      DialogLogin,
      DialogDealer,
      DialogDealerGroup,
      // Bulletin
    },
    props: {
      promotionList: {
        type: Array,
        default: () => {
          return []
        },
      },
      bulletinList: {
        type: Array,
        default: () => {
          return []
        },
      }
    },
    data() {
      return {
        slickOptions:{
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          centerMode: true,
          centerPadding: '33px',
        },
        isDialogLoginVisible: false,
        isDialogDealerVisible: false,
        isDialogDealerGroupVisible: false,
        callbackLogin: () => {
        },
      }
    },
    computed: {
      ...authComputed,
    },
    methods: {
      formattedList(list) {
        return list.map((item) => ({
          title: item.title,
          publish_up: item.publish_up,
          description: item.description,
          introimage: item.introimage,
          brands: item.brands[0],
          extrafields: item.extrafields,
          to: {
            name: 'news-item',
            params: {
              categoryAlias: item.category_alias.split('/')[1],
              newsAlias: item.alias,
            },
          },
          isdealer: item.extrafields.dealer_only.value === "1"
        }))
      },
      goToView(item) {
        const loggedInFn = () => {
          this.isDialogLoginVisible = false;
          this.$nextTick(() => {
            if(item.isdealer && this.currentMember?.groupId !== 6) {
              this.isDialogDealerGroupVisible = true
            } else {
              this.$router.push(item.to)
            }
          })
        };

        if(this.loggedIn) {
          loggedInFn()
        } else {
          this.callbackLogin = () => {
            loggedInFn()
          };
          this.isDialogDealerVisible = true
        }
      },
      showLogin(val) {
        this.isDialogLoginVisible = val
        this.isDialogDealerVisible = false
      }
    }
  }
</script>

<template>
  <div class="section pb-0" :class="$style.SectionMobileNews">
    <div class="container">
      <h2 class="SectionMobileNews__title text-xl mb-3">最新消息</h2>
      <div :class="$style.news">
        <Slick
          ref="slick"
          :options="slickOptions"
          class="SectionMobileNews__carouselList slick"
          
        >
          <template v-for="(item,$index) in formattedList(promotionList)">
            <NewsItem
              :key="$index"
              :item="item"
              content-type="news"
              class="SectionMobileNews__newsItem"
              @goTo="goToView"
            />
          </template>
          
        </Slick>
      </div>
    </div>
    <DialogDealerGroup
      :visible.sync="isDialogDealerGroupVisible"
    />
    <DialogDealer
      :visible.sync="isDialogDealerVisible"
      @isShowlogin="showLogin"
    />
    <DialogLogin
      :visible.sync="isDialogLoginVisible"
      @login="callbackLogin"
    />
  </div>
</template>

<style lang="scss" module>
  .SectionMobileNews {
    :global {
      .container {
        padding-right: 0;
      }
      .SectionMobileNews {
        &__carouselList {
          .slick-list {
              padding-left: 0px!important; // half partial
          }

          .slick-slide {
           
            // padding-right: 55px;
            // margin-left: -38px;
            // &.slick-active {
            //   margin-left: 50px;
            // }
          }
        }
        &__newsItem {
          padding: 0 12px 0 0;
        }
      }
    }
  }
</style>
